<template>
  <div class="col-12">
    <div
      style="font-size: 18px"
      class="q-mb-lg text-brand-1 text-weight-medium"
    >
      <span>Utilize os campos para filtrar a lista de menus</span>
    </div>
    <div
      class="row col-12 text-brand-1 items-center text-weight-bold q-gutter-x-md q-mb-sm"
    >
      <div class="col-2">
        <div>Nome</div>
        <q-input
          label-color="grey-6"
          label="Digite o nome para filtrar"
          dense
          outlined
          debounce="500"
          v-model="filtros.nome"
        />
      </div>
      <div class="col-2">
        <div>Descrição</div>
        <q-input
          label-color="grey-6"
          label="Digite a descrição para filtrar"
          dense
          outlined
          debounce="500"
          v-model="filtros.descricao"
        />
      </div>
    </div>
    <q-linear-progress v-if="loading" indeterminate size="3px" />
    <q-table
      class="my-sticky-dynamic col-12"
      :columns="columns"
      dense
      :rows="listaSubmenu"
      selection="single"
      v-model:selected="selected"
      v-model:pagination="pagination"
      no-data-label="Nenhum menu criado."
      :hide-bottom="listaSubmenu.length > 0"
      flat
    >
      <template v-slot:header="props">
        <q-tr :props="props">
          <q-th v-for="col in props.cols" :key="col.name" :props="props">
            <span>{{ col.label }}</span>
          </q-th>
        </q-tr>
      </template>
      <template v-slot:body="props">
        <q-tr>
          <q-td>
            {{ props.row.id }}
          </q-td>
          <q-td>
            {{ props.row.nome }}
          </q-td>
          <q-td>
            <div v-if="!props.selected">
              {{ props.row.descricao }}
            </div>
            <div v-else>
              <q-input
                class="input-tabela"
                dense
                outlined
                v-model="props.row.descricao"
              />
            </div>
          </q-td>
          <q-td>
            <q-icon size="sm" :name="props.row.icone" v-if="!props.selected">
            </q-icon>
            <div v-else>
              <q-input
                class="input-tabela"
                dense
                outlined
                v-model="props.row.icone"
              />
            </div>
          </q-td>
          <q-td>
            <div v-if="!props.selected">
              {{ props.row.nomeVisualizacao }}
            </div>
            <div v-else>
              <q-input
                class="input-tabela"
                dense
                outlined
                v-model="props.row.nomeVisualizacao"
              />
            </div>
          </q-td>
          <q-td>
            <div v-if="!props.selected">
              {{ props.row.indice }}
            </div>
            <div v-else>
              <q-input
                class="input-tabela"
                dense
                outlined
                v-model="props.row.indice"
              />
            </div>
          </q-td>
          <q-td class="coluna-btn">
            <router-link
              :to="{
                name: 'backoffice-gestao-menu-submenu-detalhe',
                params: {
                  id: props?.row?.id,
                },
              }"
            >
              <q-btn icon="article" color="blue" flat round />
            </router-link>
          </q-td>
          <q-td class="coluna-btn">
            <div v-if="!props.selected">
              <q-btn
                icon="edit"
                flat
                color="primary"
                round
                @click="(props.selected = true), (submenu = { ...props.row })"
              />
            </div>
            <div v-else>
              <q-btn
                icon="done"
                color="positive"
                flat
                round
                @click="editarSubmenu(props.row)"
              />
            </div>
          </q-td>
          <q-td class="coluna-btn">
            <q-btn
              icon="delete"
              flat
              color="red"
              round
              @click="excluirSubmenu(props.row.id)"
            />
          </q-td>
        </q-tr>
      </template>
    </q-table>
    <div
      v-if="listaSubmenu.length > 14 || pagination.page > 1"
      class="row justify-center q-mt-md"
    >
      <q-pagination
        :disable="disable"
        v-model="pagination.page"
        color="brand-5"
        active-color="secondary"
        active-text-color="white"
        :max="pagesNumber"
        :max-pages="5"
        :boundary-numbers="false"
        :direction-links="true"
        size="sm"
      />
    </div>
    <ModalInformacaoesAdicionais
      :rightDrawerOpen="modal"
      @fecharModal="fecharModal()"
      :nome-modal="'Adicionar Menu'"
      :classTitulo="'text-brand-1'"
    >
      <template v-slot:conteudo-modal>
        <div>
          <div class="text-brand-1">Nome</div>
          <q-input ref="inputNome" dense outlined v-model="submenuCriar.nome" />
        </div>
        <div class="q-mt-sm">
          <div class="text-brand-1">Descricao</div>
          <q-input dense outlined v-model="submenuCriar.descricao" />
        </div>
        <div class="q-mt-sm">
          <div class="text-brand-1">Nome Visualização</div>
          <q-input dense outlined v-model="submenuCriar.nomeVisualizacao" />
        </div>
        <div class="q-mt-sm">
          <div class="text-brand-1">Índice</div>
          <q-input type="number" dense outlined v-model="submenuCriar.indice" />
        </div>
        <div class="text-brand-1 q-mt-sm">
          <div>
            Ícone
            <a
              target="_blank"
              class="text-brand-1"
              href="https://fonts.google.com/icons?icon.set=Material+Icons"
            >
              <q-icon style="cursor: pointer" name="info" size="23px" />
            </a>
          </div>
          <q-input v-model="submenuCriar.icone" dense outlined />
        </div>
        <div class="text-brand-1 row col-12 justify-center q-mt-md">
          <q-icon
            v-if="submenuCriar.icone"
            :name="submenuCriar.icone"
            size="sm"
          />
          <div v-else>Digite para visualizar o ícone</div>
        </div>
      </template>
      <template v-slot:botao-modal>
        <div>
          <q-btn
            icon="add"
            color="positive"
            no-caps
            label="Criar"
            @click="criarSubmenu()"
          />
        </div>
      </template>
    </ModalInformacaoesAdicionais>
    <div @click="fecharModal()" v-if="modal" class="mascara"></div>
  </div>
</template>

<script>
import { computed, onMounted, ref, watch } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";

import ModalInformacaoesAdicionais from "../../requisicao/components/ModalInformacaoesAdicionais.vue";

const columns = [
  {
    name: "id",
    label: "ID",
    align: "left",
  },
  {
    name: "nome",
    label: "Nome",
    align: "left",
  },
  {
    name: "descricao",
    label: "Descrição",
    align: "left",
  },
  {
    name: "icone",
    label: "Ícone",
    align: "left",
  },
  {
    name: "nomeVisualizacao",
    label: "Nome Visualização",
    align: "left",
  },
  {
    name: "indice",
    label: "Índíce",
    align: "left",
  },
  {
    name: "detalhe",
    label: "Detalhe",
    align: "left",
  },
  {
    name: "editar",
    label: "Editar",
    align: "left",
  },
  {
    name: "excluir",
    label: "Excluir",
    align: "left",
  },
];
export default {
  components: { ModalInformacaoesAdicionais },
  emits: ["fecharModal"],
  props: {
    modal: {
      type: Boolean,
    },
  },
  setup(props, { emit }) {
    const store = useStore();
    const quasar = useQuasar();

    const listaSubmenu = ref([]);
    const selected = ref([]);
    const submenu = ref({});
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 10,
      rowsNumber: 6,
    });
    const disable = ref(false);
    const filtros = ref({
      nome: "",
      descricao: "",
    });
    const loading = ref(false);
    const submenuCriar = ref({
      nome: "",
      descricao: "",
      nomeVisualizacao: "",
      indice: "",
      icone: "",
    });
    const inputNome = ref(null);

    const listarSubmenus = async (perPage = 15, page = 1) => {
      disable.value = true;
      loading.value = true;
      try {
        const response = await store.dispatch("office/listarSubmenus", {
          perPage,
          page,
          nome: filtros.value.nome,
          descricao: filtros.value.descricao,
        });

        listaSubmenu.value = response.data.resultado.dados;
        pagination.value.page = response.data.resultado.currentPage;
        pagination.value.rowsNumber = response.data.resultado.total;
        pagination.value.rowsPerPage = response.data.resultado.perPage;
        disable.value = false;
        loading.value = false;
      } catch (error) {
        console.log(error);
        disable.value = false;
        loading.value = false;
      }
    };

    const criarSubmenu = async () => {
      if (submenuCriar.value.nome === "") {
        quasar.notify({
          message: "O campo nome não pode ser vazio.",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      if (submenuCriar.value.nomeVisualizacao === "") {
        quasar.notify({
          message: "O campo nome não pode ser vazio.",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      try {
        await store.dispatch("office/criarSubmenu", {
          nome: submenuCriar.value.nome,
          descricao: submenuCriar.value.descricao,
          indice: submenuCriar.value.indice,
          nomeVisualizacao: submenuCriar.value.nomeVisualizacao,
          icone:
            submenuCriar.value.icone != "" ? submenuCriar.value.icone : "done",
        });
        resetSubmenuCriar();
        quasar.notify({
          message: "Menu criado com sucesso.",
          color: "positive",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        listarSubmenus();
        fecharModal();
      } catch (error) {
        console.log(error);
      }
    };

    const fecharModal = () => {
      emit("fecharModal");
    };

    const excluirSubmenu = async (submenuId) => {
      try {
        await store.dispatch("office/excluirSubmenu", {
          submenuId,
        });
        listarSubmenus(pagination.value.rowsPerPage, pagination.value.page);
        quasar.notify({
          message: "Menu excluído com sucesso.",
          color: "positive",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        console.log(error);
      }
    };

    const editarSubmenu = async (value) => {
      if (
        value.descricao === submenu.value.descricao &&
        value.indice === submenu.value.indice &&
        value.nomeVisualizacao === submenu.value.nomeVisualizacao &&
        value.icone === submenu.value?.icone
      ) {
        selected.value = [];
        return;
      }
      try {
        await store.dispatch("office/editarSubmenu", {
          submenuId: value.id,
          descricao: value.descricao,
          indice: value.indice,
          nomeVisualizacao: value.nomeVisualizacao,
          icone: value.icone,
        });
        listarSubmenus(pagination.value.rowsPerPage, pagination.value.page);
        selected.value = [];
        quasar.notify({
          message: "Menu editado com sucesso.",
          color: "positive",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        console.log(error);
      }
    };

    const resetSubmenuCriar = () => {
      submenuCriar.value = {
        nome: "",
        descricao: "",
        nomeVisualizacao: "",
        indice: "",
        icone: "",
      };
    };

    watch(
      () => props.atualizar,
      () => {
        listarSubmenus(pagination.value.rowsPerPage, pagination.value.page);
      }
    );

    watch(
      () => inputNome?.value,
      () => {
        if (
          inputNome?.value != null &&
          props.modal &&
          submenuCriar.value.nome == ""
        ) {
          inputNome.value?.focus();
        }
      }
    );

    watch(
      () => pagination.value.page,
      () => {
        listarSubmenus(pagination.value.rowsPerPage, pagination.value.page);
      }
    );

    watch([() => filtros.value.nome, () => filtros.value.descricao], () => {
      listarSubmenus();
    });

    onMounted(() => {
      listarSubmenus();
    });

    return {
      columns,
      listarSubmenus,
      listaSubmenu,
      excluirSubmenu,
      submenu,
      editarSubmenu,
      criarSubmenu,
      disable,
      selected,
      fecharModal,
      filtros,
      submenuCriar,
      resetSubmenuCriar,
      loading,
      pagination,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      inputNome,
    };
  },
};
</script>

<style scoped>
.q-table__top,
thead tr:first-child th {
  background-color: #d9effc;
}

thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:first-child th {
  top: 0;
}

.q-table--loading thead tr:last-child th {
  top: 48px;
}
.my-sticky-dynamic {
  max-height: 400px;
}
thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:last-child th {
  top: 48px;
}
thead tr:first-child th {
  top: 0;
}
tbody tr .coluna-btn {
  width: 120px;
}
.input-tabela {
  width: 180px;
}
.mascara {
  background-color: black;
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2;
  opacity: 0.4;
}
</style>
